var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { observable } from 'mobx';
import { serializable, object } from 'serializr';
import WebSocketStore from './WebSocketStore';
import EditorWorkspacesStore from './EditorWorkspacesStore';
export default class SidebarStore {
    constructor(graph) {
        this.server = new WebSocketStore(graph);
        this.editorWorkspaces = new EditorWorkspacesStore();
    }
}
__decorate([
    observable,
    serializable(object(WebSocketStore)),
    __metadata("design:type", typeof (_a = typeof WebSocketStore !== "undefined" && WebSocketStore) === "function" ? _a : Object)
], SidebarStore.prototype, "server", void 0);
__decorate([
    observable,
    serializable(object(EditorWorkspacesStore)),
    __metadata("design:type", typeof (_b = typeof EditorWorkspacesStore !== "undefined" && EditorWorkspacesStore) === "function" ? _b : Object)
], SidebarStore.prototype, "editorWorkspaces", void 0);
